import { addDoc, collection } from 'firebase/firestore';
import { CreateVisitData } from '../../../../global';
import { firestore } from '../utils/firebase';

export const addVisit = async (data: CreateVisitData): Promise<void> => {
  const ref = collection(firestore, 'visits');
  await addDoc(ref, data);
};
